export enum PAYMENT_TYPES {
  PAY_FULL_UPFRONT = "PAY_FULL_UPFRONT",
  PAY_IN_STORE = "PAY_IN_STORE"
}
